import { SnackbarAction } from "notistack";
import { textService } from "../../services/textService";
import { SystemEntityCollections } from "../../shared/enums/shared-enums";
import { Text, TextFilters } from "../../types/text";
import { useEntityQueryClient } from "./entityQueryClient";
import { extractTextEditLink } from "../../components/entitiesReferences/InternalEntityLink";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import useTextLogic from "../logic/textLogic";

const useTextQuery = (systemLanguageType: Text["system_language_type"]) => {
  const navigate = useNavigate();
  const { defaultText, getDisplayName } = useTextLogic(systemLanguageType);
  return useEntityQueryClient<Text, TextFilters>({
    service: textService,
    collection: SystemEntityCollections.TEXT,
    defaultEntity: defaultText,
    snackbarDisplayName: getDisplayName,
    snackbarAction: (data: Text): SnackbarAction => (
      <Button
        variant="text"
        onClick={() => navigate(extractTextEditLink(data))}
        sx={{ color: "white" }}
      >
        View Text
      </Button>
    ),
  });
};

export default useTextQuery;
